import { ISchedule } from '../../repositories/newbuilding-flat-tour-booking/entities/Models/Schedule';

export function isValidFlatTourBookingSchedule(schedule: ISchedule) {
  const { general, availableDateIntervals } = schedule;

  return general.length === 7 && !!availableDateIntervals.length;
}
